/** See `src/i18n/locales/en/pilots.ts`. */
export const pilots = {
  page: {
    title: 'Pilotprojekte',
    lead: 'Pilotprojekte bei {{company}}.',
    noScope: 'Wähle ein Unternehmen, um dessen Pilotprojekte zu sehen.',
    listTitle: 'Pilotprojekte',
    empty: 'Noch keine Pilotprojekte.',
  },
  status: {
    draft: 'Entwurf',
    baseline: 'Basiswert',
    active: 'Aktiv',
    interim_review: 'Zwischenevaluation',
    final_review: 'Abschlussevaluation',
    completed: 'Abgeschlossen',
    scaled: 'Skaliert',
  },
  phases: {
    baseline: 'Basismessung',
    interim: 'Zwischenevaluation',
    final: 'Abschlussevaluation',
  },
  kpis: {
    participationRate: 'Teilnahmequote',
    activeUsers: 'Aktive Nutzer',
    dailyUsage: 'Tägliche Nutzung',
    satisfaction: 'Mitarbeiterzufriedenheit',
    avgVitality: 'Ø Vitalität',
    aiCoachUsage: 'KI-Coach-Nutzung',
    challengeUsage: 'Challenge-Nutzung',
    rolloutReadiness: 'Rollout-Empfehlung',
  },
  form: {
    title: 'Neues Pilotprojekt',
    name: 'Name',
    startDate: 'Startdatum',
    departments: 'Abteilungen',
    submit: 'Pilotprojekt erstellen',
  },
  detail: {
    title: 'Pilotprojekt',
    lead: 'Auswertung des Vitalitäts-Pilotprojekts mit KPIs, Trends, Erkenntnissen und einer fundierten Rollout-Entscheidung.',
    exportPdf: 'Bericht exportieren (PDF)',
    hero: {
      badge: {
        success: 'Pilotprojekt erfolgreich',
        partial: 'Pilotprojekt in Arbeit',
        atRisk: 'Aufmerksamkeit erforderlich',
        pending: 'Pilotprojekt läuft',
      },
      goals: {
        success: 'Alle KPI-Ziele erreicht',
        partial: 'Ein Teil der KPI-Ziele erreicht',
        atRisk: 'KPI-Ziele noch nicht erreicht',
        pending: 'Noch nicht genug Daten für eine Empfehlung',
      },
      headlinePrefix: {
        success:
          'Das Pilotprojekt beweist, dass NOLATR Fit die Vitalität messbar verbessert — Empfehlung:',
        partial: 'Das Pilotprojekt zeigt Verbesserung — Empfehlung:',
        atRisk: 'Das Pilotprojekt zeigt noch keine messbare Verbesserung — Empfehlung:',
        pending: 'Es gibt noch nicht genug Daten für eine Empfehlung zum',
      },
      headlineAdvice: {
        success: 'auf die ganze Organisation skalieren.',
        partial: 'das Pilotprojekt für mehr Daten verlängern.',
        atRisk: 'erst nachbessern vor dem Skalieren.',
        pending: 'Skalieren.',
      },
    },
    summary: {
      participation: 'Teilnahme',
      dailyActive: 'Täglich aktiv',
      stress: 'Stress',
      sleep: 'Schlaf',
      goal: 'Ziel {{value}}%',
      vsBaseline: 'vs. Basismessung',
      minutes: '{{value}} Min.',
    },
    aiSummaryTitle: 'KI-Zusammenfassung',
    recommendationEmpty: 'Noch keine Zusammenfassung erfasst.',
    kpisTitle: 'KPIs',
    chartTitle: 'Vitalität & Aktivität während des Pilotprojekts',
    chartCurrent: 'Aktuell',
    noData: 'Noch keine Daten.',
    participantCount: '{{count}} Teilnehmende',
    evaluationsTitle: 'Erkenntnisse & Empfehlungen',
    conclusionsTitle: 'Erkenntnisse',
    recommendationsListTitle: 'Empfehlungen',
    evaluationsEmpty: 'Noch keine Evaluationen erfasst.',
    evaluationPhase: 'Phase',
    evaluationConclusions: 'Erkenntnisse',
    evaluationRecommendations: 'Empfehlungen',
    decisionTitle: 'Entscheidung',
    scaleRequiresCompleted: 'Skalierung ist erst nach Abschluss der Abschlussevaluation möglich.',
  },
  actions: {
    new: 'Neues Pilotprojekt',
    cancel: 'Abbrechen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    addEvaluation: 'Evaluation hinzufügen',
    extend: 'Verlängern',
    scale: 'Skalieren',
  },
} as const;
